import { createIcon } from './icon-utils';

export const NewWindowIcon = createIcon({
  path: 'M18.628 4.311h-3.252a.75.75 0 1 1 0-1.5h5.062a.75.75 0 0 1 .75.75v5.063a.75.75 0 1 1-1.5 0V5.372l-9.97 9.97a.75.75 0 0 1-1.06-1.061l9.97-9.97zm-7.19 1.875a.75.75 0 1 1 0 1.5h-6.75a.375.375 0 0 0-.375.375v11.25c0 .207.168.375.375.375h11.25a.375.375 0 0 0 .375-.375v-6.75a.75.75 0 1 1 1.5 0v6.75c0 1.036-.84 1.875-1.875 1.875H4.688a1.875 1.875 0 0 1-1.875-1.875V8.061c0-1.036.84-1.875 1.875-1.875h6.75z',
});
